module.exports = __webpack_public_path__ + "static/Mike-574ac22ed4a217546f6805efc6a51e58.jpg";